import { matchPath, useLocation } from "react-router-dom";

import { AbsoluteRoute } from "../../core/routes/absoluteRoutes";
import { FEATURES, Feature, LENS_SCHEDULER_FEATURES } from "../models";

export interface SelectedFeatureResult {
    selectedFeature: Feature | null;
}

export const getSelectedFeature = (pathname: string): Feature | null => {
    const pathParts = pathname.split("/");
    const partsSet = new Set(pathParts);

    if (matchPath({ path: AbsoluteRoute.SUBMIT, end: false }, pathname)) {
        return Feature.lensSubmit;
    }

    if (matchPath({ path: AbsoluteRoute.CK_ROOT, end: true }, pathname)) {
        return Feature.cameraKit;
    }

    for (const feature of LENS_SCHEDULER_FEATURES) {
        if (pathname.includes(feature)) {
            return feature;
        }
    }

    for (const feature of FEATURES) {
        if (partsSet.has(feature)) {
            return feature;
        }
    }

    if (partsSet.has("lens")) {
        return Feature.lenses;
    }

    return null;
};

export const useSelectedFeature = (): SelectedFeatureResult => {
    const { pathname } = useLocation();

    const selectedFeature = getSelectedFeature(pathname);

    return {
        selectedFeature,
    };
};
